<template>
  <div style="display: flex; align-items: flex-start">
    <el-card style="width: 100%">
      <div
        slot="header"
        class="clearfix"
      >
        <span>Importok</span>
      </div>
      <table-filter
        v-if="config"
        :config="config"
        action="imports/fetchAllWithPagination"
      />
      <import-list />
    </el-card>
  </div>
</template>

<script>
  import ImportList from '../../components/imports/List';
  import TableFilter from '../../components/TableFilter';

  export default {
    components: {
      ImportList,
      TableFilter,
    },
    data() {
      return {
        config: null,
      };
    },
    async mounted() {
        await this.setConfig();
    },
    methods: {
      async setConfig() {
        let users = this.$store.getters['user/users'];

        if (!users.length) {
          await this.$store.dispatch('user/fetchAll');
          users = this.$store.getters['user/users'];
        }

        this.config = [
          {
            type: 'select',
            options: users,
            name: 'user_id',
            label: 'Felhasználó',
            labelCallback: user => user && user.full_name || '',
            valueKey: 'id',
          },
          {
            type: 'select',
            options: [
              {
                label: 'Folyamatban',
                status: 'pending'
              },
              {
                label: 'Sikeres',
                status: 'done'
              },
              {
                label: 'Hiba',
                status: 'failed'
              },
            ],
            name: 'status',
            label: 'Státusz',
            labelCallback: status => status.label,
            valueKey: 'status',
            defaultSearch: true
          },
          {
            type: 'select',
            options: [
              {
                label: 'Rakodási lista',
                type: 'stowage'
              },
            ],
            name: 'type',
            label: 'Típus',
            labelCallback: status => status.label,
            valueKey: 'type'
          },
          {
            type: 'text',
            name: 'file',
            label: 'Fájl',
          },
          {
            type: 'date',
            name: 'created_at',
            label: 'Dátum',
          },
        ];
      }
    },
  };
</script>
